<style>

</style>
<template>
    <div class="result-ranking-list-wrap">
        <div class="tournament-title"><p>{{tournament.tnmtName}}</p></div>
        <div class="table-wrap"  ref="participantList">
            <empty-content style="height: calc(100%);" content="검색결과가 없습니다" v-if="!ranks || ranks.statisticTeamRankList.length<=0"></empty-content>
            <table class="team-play-list" v-else>
                <tr>
                    <th>번호</th>
                    <th>소속</th>
                    <th>입상팀수</th>
                    <th>입상자 명단보기</th>
                </tr>
                <tr v-for="(rank, rankIndex) in ranks.statisticTeamRankList" >
                    <td>{{rankIndex +1 }}</td>
                    <td>{{rank.teamName}}</td>
                    <td>{{rank.statisticTeamPlayerList.length}}</td>
                    <td><p class="detail-btn" @click="detailLocationFunc(rank)">입상자 명단</p></td>
                </tr>
            </table>

        </div>

    </div>
</template>
<script>
    import {mapState} from 'vuex'
    import EmptyContent from "../../common/EmptyContent";
    export default{
        components: {EmptyContent},
        computed: {
            ...mapState('tournaments', ['tournament', 'ranks'])
        },
        methods:{
            detailLocationFunc(rank){
                const scrollTop = this.$refs.participantList.scrollTop
                localStorage.setItem('team-rank-player-scroll', scrollTop)
                this.$router.push(`${this.$route.path}/detail?team_name=${rank.teamName}`)
            },
            handleScroll(event){
                const scrollTop = event.target.scrollTop
                localStorage.setItem('TeamRankPlayerList', scrollTop)
            },
        },
        mounted() {
            localStorage.removeItem('team-rank-player-detail-scroll')
            if(localStorage.getItem('TeamRankPlayerList')){
                this.$refs.participantList.scrollTop = localStorage.getItem('TeamRankPlayerList')
            }
        },
        created() {
            window.addEventListener('scroll', this.handleScroll)
        },
        destroyed() {
            window.removeEventListener('scroll', this.handleScroll);
        },
    }
</script>
